export class ConveyedPropertyValidateResultDto {
    inCollectionCommunities: string;
}
